"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFeatureAccess = void 0;
const fetchInstance_1 = require("../../../utils/fetchInstance");
/**
* @summary Resolve which UI nodes on a surface (e.g. "rules.form") are AVAILABLE / LOCKED_NEEDS_UPGRADE / HIDDEN for the current shop
*/
const getFeatureAccess = (params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/feature-access`, method: 'get',
        params
    });
};
exports.getFeatureAccess = getFeatureAccess;
